import { useState } from 'react';
import { useData } from '@/context/DataContext';
import Dropdown from '@/components/base/Dropdown';

const typeIcons: Record<string, string> = {
  warning: 'ri-alarm-warning-line',
  danger: 'ri-error-warning-line',
  info: 'ri-information-line',
  success: 'ri-check-double-line',
};

const typeColors: Record<string, string> = {
  warning: 'bg-accent-100 text-accent-700',
  danger: 'bg-accent-100 text-accent-700',
  info: 'bg-primary-100 text-primary-700',
  success: 'bg-primary-100 text-primary-700',
};

export default function NotificationsDropdown() {
  const { notifications } = useData();
  const [readIds, setReadIds] = useState<string[]>([]);

  const isRead = (id: string) => {
    const n = notifications.find((x) => x.id === id);
    return (n?.read ?? false) || readIds.includes(id);
  };
  const unread = notifications.filter((n) => !isRead(n.id)).length;

  const markAllRead = () => setReadIds(notifications.map((n) => n.id));
  const markRead = (id: string) => setReadIds((prev) => (prev.includes(id) ? prev : [...prev, id]));

  return (
    <Dropdown
      menuClassName="w-80 sm:w-96"
      triggerClassName="relative flex h-9 w-9 items-center justify-center rounded-md text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
      trigger={
        <>
          <i className="ri-notification-3-line text-xl" />
          {unread > 0 && (
            <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-accent-500 px-1 text-[10px] font-bold text-white">
              {unread}
            </span>
          )}
        </>
      }
    >
      {(close) => (
        <div className="py-1">
          <div className="flex items-center justify-between px-3 py-2">
            <p className="text-sm font-semibold text-foreground-900">Bildirimler</p>
            {unread > 0 && (
              <button
                type="button"
                onClick={markAllRead}
                className="cursor-pointer text-xs font-semibold text-primary-600 hover:text-primary-700"
              >
                Tümünü okundu işaretle
              </button>
            )}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {notifications.length === 0 ? (
              <div className="px-4 py-6 text-center text-sm text-foreground-500">Bildirim yok</div>
            ) : (
              notifications.map((n) => (
                <button
                  key={n.id}
                  type="button"
                  onClick={() => markRead(n.id)}
                  className={`flex w-full cursor-pointer items-start gap-3 rounded-md px-3 py-2.5 text-left transition-colors hover:bg-background-100 ${
                    !isRead(n.id) ? 'bg-background-100/60' : ''
                  }`}
                >
                  <span className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md ${typeColors[n.type]}`}>
                    <i className={typeIcons[n.type]} />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-sm leading-snug text-foreground-800">{n.text}</span>
                    <span className="mt-0.5 block text-xs text-foreground-400">{n.date}</span>
                  </span>
                  {!isRead(n.id) && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-primary-500" />}
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </Dropdown>
  );
}